import axios, {AxiosRequestConfig} from 'axios';
import {push} from 'connected-react-router';

import {ROUTE} from 'containers/App/constants';
import {store} from 'index';

import {getAccessToken, getRefreshToken} from '../../utils/cookies';
import {ApiError} from 'api/error';
import {refreshToken} from 'auth/api';
import {logout} from '../../store/actions';
import {saveTokens} from 'auth/utils';
import {getAPIEndpoint} from 'api/utils';

export const WISBIT_ORGANIZATION = 'X-Wisbits-Organization';

type HeaderName = 'Content-Type' | 'Authorization' | 'X-Wisbits-Organization';

export type Headers = {
  [name in HeaderName]?: string;
};

async function rawRequest(
  url: string,
  options?: Partial<AxiosRequestConfig>,
  returnAllResponse?: boolean
) {
  const {
    method = 'GET',
    data,
    headers,
    params,
    responseType = 'json',
  } = options || {};

  const accessToken = getAccessToken() || '';

  const updatedHeaders: Headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
    ...headers,
  };

  try {
    const response = await axios({
      method,
      url: getAPIEndpoint(url),
      data,
      headers: updatedHeaders,
      params,
      responseType,
    });

    if (returnAllResponse) {
      return response;
    }

    return response.data;
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  } catch (e: any) {
    throw new ApiError(e);
  }
}

export default async function request(
  url: string,
  options?: Partial<AxiosRequestConfig>,
  returnAllResponse?: boolean
) {
  try {
    return await rawRequest(url, options, returnAllResponse);
  } catch (e) {
    const err = e as ApiError;

    const {dispatch} = store;

    // If authorization error
    if (err.needLogin) {
      try {
        // Try refreshing the token and retry the request.
        const tokens = await refreshToken(getRefreshToken());
        saveTokens(tokens);
        return await rawRequest(url, options, returnAllResponse);
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      } catch (error: any) {
        console.error(error);
        // If refresh/retry didn't go through logout.
        dispatch(logout());
        dispatch(push(ROUTE.Index));
        return;
      }
    } else {
      throw err;
    }
  }
}
